export default __webpack_public_path__ + "static/media/crew-10.d0f632bf.svg";